/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import { Button } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useFormikContext } from 'formik';

export const BeamCancelButton = () => {
  const formikContext = useFormikContext();
  const history = useHistory();

  return (
    <Button
      variant="contained"
      size="large"
      disabled={formikContext.isSubmitting}
      sx={{ backgroundColor: '#141D24', height: '40px', width: '100px' }}
      onClick={() => {
        history.goBack();
      }}
    >
      Cancel
    </Button>
  );
};
